import React from "react";
import Footer from "../Components/Footer";
import Navbar from "../Components/Navbar";
const TermsAndConditions = () => {
  return (
    <>
      <Navbar />
      <div className="container my-5 p-4 border rounded-lg shadow-lg bg-white">
        <h2 className="text-center font-bold text-2xl mb-4">Terms and Conditions</h2>
        <p className="text-gray-600 text-sm text-center mb-6">Last updated on Mar 3, 2025</p>

        <p>
          For the purpose of these Terms and Conditions, the terms <strong>"we", "us", "our"</strong> refer to Irfan Electricals, whose registered/operational office is <br />
          <em>City Survey No.170/383, Shop No.2, Plot No. 383, Motitalav Road, Vip Bhavnagar, GUJARAT 364006</em>. <br />
          The terms <strong>"you", "your", "user", "visitor"</strong> refer to any natural or legal person who is visiting our website and/or has agreed to purchase from us.
        </p>

        <h3 className="font-semibold mt-4">1. Website Usage</h3>
        <p>
          Your use of the website and/or purchase from us is governed by the following Terms and Conditions:
        </p>
        <ul className="list-disc pl-6">
          <li>The content of this website is subject to change without notice.</li>
          <li>
            Neither we nor any third parties provide any warranty or guarantee as to the accuracy, timeliness, performance,
            completeness, or suitability of the information and materials found or offered on this website for any particular purpose.
          </li>
          <li>
            You acknowledge that such information and materials may contain inaccuracies or errors, and we expressly exclude
            liability for any such inaccuracies or errors to the fullest extent permitted by law.
          </li>
        </ul>

        <h3 className="font-semibold mt-4">2. Liability and Responsibility</h3>
        <p>
          Your use of any information or materials on our website and/or product pages is entirely at your own risk, for which we shall not be liable.
          It shall be your responsibility to ensure that any products, services, or information available through our website meet your specific requirements.
        </p>

        <h3 className="font-semibold mt-4">3. Copyright and Trademarks</h3>
        <p>
          Our website contains material that is owned by or licensed to us, including but not limited to the design, layout, look, appearance, and graphics.
          Reproduction is prohibited other than in accordance with the copyright notice, which forms part of these terms and conditions.
        </p>
        <p>
          All trademarks reproduced on our website that are not the property of or licensed to the operator are acknowledged on the website.
        </p>

        <h3 className="font-semibold mt-4">4. Unauthorized Use</h3>
        <p>
          Unauthorized use of information provided by us shall give rise to a claim for damages and/or be a criminal offense.
        </p>

        <h3 className="font-semibold mt-4">5. External Links</h3>
        <p>
          From time to time, our website may include links to other websites. These links are provided for your convenience to provide further information.
        </p>
        <p>
          You may not create a link to our website from another website or document without Irfan Electricals’s prior written consent.
        </p>

        <h3 className="font-semibold mt-4">6. Governing Law</h3>
        <p>
          Any dispute arising out of the use of our website, purchases made with us, or any engagement with us is subject to the laws of India.
        </p>

        <h3 className="font-semibold mt-4">7. Payment Authorization</h3>
        <p>
          We shall be under no liability whatsoever in respect of any loss or damage arising directly or indirectly out of the decline of authorization for any transaction,
          on account of the cardholder having exceeded the preset limit mutually agreed by us with our acquiring bank from time to time.
        </p>
      </div>
      <Footer />
    </>
  );
};

export default TermsAndConditions;
